/* @flow */
// Fixed player bar along the bottom of the page (like Spotify's):
// what's playing on the left, controls and progress in the middle, volume on the right.
import React from 'react'
import PlayerControls from '../PlayerControls'
import SongProgress from '../SongProgress'
import Volume from '../Volume'
import './NowPlayingBar.css'

export type Props = {
  title: string,
  artist: string,
  stationName: string,
  stationImage: string,
  isAdvert: boolean,
  playing: boolean,
  position: number,
  duration: number,
  showVolume: boolean,
  volume: number,
  onPlayPause: () => void,
  onSkip: () => void,
  onDislike: () => void,
  onVolumeChange: (v: number) => void,
  onMute: () => void,
  onLoud: () => void
}

export default (props: Props) => {
  const {
    title, artist, stationName, stationImage, isAdvert, playing, position, duration,
    showVolume, volume, onPlayPause, onSkip, onDislike, onVolumeChange, onMute, onLoud
  } = props
  return (
    <div className="np-bar" role="region" aria-label="Player">
      <div className="np-bar__track">
        { stationImage && <img className="np-bar__art" src={ stationImage } alt="" /> }
        <div className="np-bar__text">
          <span className={ `np-bar__title${isAdvert ? ' np-bar__title--advert' : ''}` } title={ title }>
            { title || 'Awesome music for your gym' }
          </span>
          <span className="np-bar__artist">
            { artist || 'Loading ...' }{ stationName ? <span className="np-bar__station"> · { stationName }</span> : null }
          </span>
        </div>
      </div>

      <div className="np-bar__centre">
        <PlayerControls
          playing={ playing }
          onSkip={ onSkip }
          onDislike={ onDislike }
          onPlayPause={ onPlayPause }
        />
        <SongProgress position={ position } duration={ duration } />
      </div>

      <div className="np-bar__right">
        {
          showVolume && (
            <Volume
              step={ 10 }
              defaultValue={ volume }
              value={ volume }
              onChange={ onVolumeChange }
              onMute={ onMute }
              onLoud={ onLoud }
            />
          )
        }
      </div>
    </div>
  )
}
